import {
  createFeatureIntroSeen,
  FeatureIntroSeenState
} from 'components/FeatureIntro/featureIntroSeen';

/**
 * "Seen" for the one-time heads-up Sit & Go introduction (EN-10748): the
 * shared storage shape (components/FeatureIntro/featureIntroSeen.ts: written on
 * the player's own dismissal, never on paint or a teardown; keyed by edition
 * and playerGUID; fails closed when storage cannot be read) under this
 * introduction's own prefix, so it and the multi-run one never read each
 * other's keys.
 */
export const HEADS_UP_INTRO_SEEN_KEY_PREFIX = 'hijack:featureIntro:headsUp:';

export type HeadsUpIntroSeenState = FeatureIntroSeenState;

const seen = createFeatureIntroSeen(HEADS_UP_INTRO_SEEN_KEY_PREFIX);

export const readHeadsUpIntroSeen = seen.read;

/** False when storage refused the write; the caller's session guard still holds. */
export const markHeadsUpIntroSeen = seen.mark;
